import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { OrderItem, OrderSummary } from "../orders";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { LoadingSpinner, ModalMessage } from "../generalLayout";
import { useEffect, useState } from "react";
import { AddressFormModal } from "../user";
import { paymentMethods } from "../../constants/config";
import { useSelector } from "react-redux";
const notCompletedColor = "#b20000";
const completedColor = "#007500";

export default function OrderDetails(props) {
  // displays the details of an order, including the items in the order, payment and delivery status, and the order summary. 
  // props:
  //    data: json with the order details
  //    delivered: json with status, date
  //    paid: json with status, date
  //    admin (Boolean): if ture, option to mark order as completed or cancel it, also sets readOnly to true
  //    readOnly (Boolean): if true, no option to 'pay now' or change pymt method
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated); 
  const [isUpdatingDeliveryStatus, setIsUpdatingDeliveryStatus] =
    useState(false);
  const [changeAddress, setChangeAddress] = useState(false);
  const [dataIsComplete, setDataIsComplete] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(paymentMethods[0]);
  const [showAlertMsg, setShowAlertMsg] = useState(false);
  // const [isLoading, setIsLoading] = useState(false); 

  const { cart, order, data } = props; 

    useEffect(() => {
    if(!cart && !order){
      if(data?.user && data?.deliveryAddress?.name && data?.deliveryAddress?.city && data?.deliveryAddress?.province && data?.deliveryAddress?.street && data?.deliveryAddress?.country && data?.deliveryAddress?.postalCode){
        setDataIsComplete(true);
      } else {
        setDataIsComplete(false);
      }
    }
  }, [cart, order, data?.user, data?.deliveryAddress]);

  const handleUpdateDeliveryStatus = async (newStatus) => {
    setIsUpdatingDeliveryStatus(true);
    await props.toggleDeliveredStatus(newStatus);
    setIsUpdatingDeliveryStatus(false);
  };

  const handleConfirmUpdateCancellationStatus = async () => {
    await props.toggleCancelledStatus(!props.cancelled.status);
  }

  const handleUpdateRefundedStatus = async (newStatus) => {
    await props.toggleRefundedStatus(newStatus);
  };

  if (!props.data) {
    return null;
  }

  const handleUpdateReturnedStatus = async (newStatus) => {
    await props.toggleReturnedStatus(newStatus);
  };

  if (!props.data) {
    return null;
  }

  const handleSubmitClick = (values) => {
    props.handleAddressSubmit(values);
    setChangeAddress(false);
  }

const handleCancelClick = () => {
  setChangeAddress(false);
}

  return (
    <>
      <Row className={`justify-content-md-center ${!(props.cart || props.order)?'mt-5':null}`} >
        <Col>
          {props.order && (
            <>
              {/* for orders, show paid/delivered/cancelled status */}
              {props?.cancelled?.status && 
              <h5
                style={{
                  color:notCompletedColor}}
                className="mt-3 mb-5"
              >
                <i className="bi bi-exclamation-circle"> This order has been cancelled</i>
              </h5>}
              <h5
                style={{
                  color: props?.paid?.status
                    ? completedColor
                    : notCompletedColor,
                }}
                className="mb-3"
              >
                <i>
                  {props?.paid?.status
                    ? `Paid ${dayjs(props?.paid?.date).format(
                        "MMM DD, YYYY"
                      )}`
                    : "Not paid"}
                </i>
                {props?.paid?.status && props?.refunded?.status && 
                <i style={{color: notCompletedColor}}> - Refunded {dayjs(props?.refunded?.date).format(
                        "MMM DD, YYYY"
                      )}</i> 
                }
                {props.admin && props?.paid?.status &&  <Button
                  onClick={() =>
                    handleUpdateRefundedStatus(!props.refunded?.status)
                  }
                  className="mt-1 mb-1 ms-3"
                  variant="outline-secondary"
                  size="sm"
                >
                  {props.refunded?.status
                    ? "Undo Refund"
                    : "Refund Issued"}{" "}
                </Button>}
             
                      
                  
              </h5>
              <h5
                style={{
                  color: props?.delivered?.status
                    ? completedColor
                    : notCompletedColor,
                }}
                className="mb-3"
              >
                <i>
                  {props?.delivered?.status
                    ? `Delivered ${dayjs(props?.delivered?.date).format(
                        "MMM DD, YYYY"
                      )}`
                    : props?.paid?.status && "Not delivered"}
                </i>
                {props?.delivered?.status && props?.returned?.status && 
                <i style={{color: notCompletedColor}}> - Returned {dayjs(props?.returned?.date).format(
                        "MMM DD, YYYY"
                      )}</i>}
                     {props.admin && props?.delivered?.status &&  <Button
                  onClick={() =>
                    handleUpdateReturnedStatus(!props.returned?.status)
                  }
                  className="mt-1 mb-1 ms-3"
                  variant="outline-secondary"
                  size="sm"
                >
                  {props.returned?.status
                    ? "Undo Returned"
                    : "Items Returned"}{" "}
                </Button>}
              </h5>
            </>
          )}
          {/* BUTTONS TO CHANGE STATUSES */}
          {props.admin ? (
            <>
              {/* admin can change delivery status and cancel an order */}
              {props?.paid?.status && !props?.cancelled?.status && !props?.returned?.status && (
                <Button
                  disabled={isUpdatingDeliveryStatus}
                  onClick={() =>
                    handleUpdateDeliveryStatus(!props.delivered.status)
                  }
                  className="mt-2 mb-4"
                >
                  {props.delivered.status
                    ? "Undo Delivered"
                    : "Mark as Delivered"}{" "}
                  {isUpdatingDeliveryStatus && (
                    <LoadingSpinner button={true} variant="light" />
                  )}
                </Button>
              )}{" "}
             
                {!props?.cancelled?.status && !props?.delivered?.status && <Button
                  onClick={() => setShowAlertMsg(true)}
                  className="mt-2 mb-4"
                  variant="danger"
                >
                 Cancel Order
                </Button>}
              
            </>
          ) : null}
        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={7} lg={8}>
          {/* for cart don't show address/pymt method fields */}
          {!props.cart && (
            <Row >
              <Col>
                <h5 style={{ display: "inline-block" }}> Shipping Address </h5>{" "}
                {!props.order && <Link onClick={() => setChangeAddress(true)}>Change</Link>}
                <p>
                  {props.data?.deliveryAddress?.name} <br />
                  {props.data?.deliveryAddress?.street} <br />
                  {props.data?.deliveryAddress?.city}
                  {" "}
                  {props.data?.deliveryAddress?.province}{" "}
                  {props.data?.deliveryAddress?.postalCode}
                  <br />
                  {props.data?.deliveryAddress?.country}
                </p>
                
              </Col>
              <Col>
                <h5> Payment Method </h5>
                {props.order ? (
                  <p>{props?.data?.paymentMethod}</p>
                ) : (
                  <Form.Select value={paymentMethod} onChange={(event) => setPaymentMethod(event.target.value)}>
                    {paymentMethods.map((method) => {
                     return <option key={method} value={method}>{method}</option>
                    })}
                  </Form.Select>
                )}
              </Col>
            </Row>
          )} 
          <Row className={props.cart?"0":"mt-5"}>
            <Col>
              {props.data.cartItems.map((item, idx) => {
                return (
                  <Card key={idx} className="my-3 border-0 border-bottom">
                    <OrderItem
                      data={item}
                      quantity={item?.count || props.cartItemQuantities[item._id].count}
                      readOnly={props?.order}
                      updateQuantity={props.updateQuantity} 
                      deleteItem={props.deleteItem} 
                    />
                  </Card>
                );
              })}
            </Col>
          </Row> 
        </Col>

        <Col md={5} lg={4}>
          <Row> 
            <Col>
              <OrderSummary data={props?.data?.orderTotal} />
              {!props.order && (
  <>
                  <Button className="mt-4" 
                  onClick={props.cart?props.handleCheckoutClick:() => props.handlePayNow(props.data, paymentMethod
                  )}
                  // only make clickable if all necessary info filled out
                   disabled={!props.cart ? !dataIsComplete : false}
                  >
                    {props.cart ? "Proceed to Checkout" : "Pay Now"}
                  </Button>
                  {isAuthenticated && !dataIsComplete && props.checkout && <div style={{color: notCompletedColor, fontSize:"small"}}>Please enter a valid address</div>}
  </> 
              )}
            </Col>
          </Row>
        </Col>
        {changeAddress && 
        <AddressFormModal handleSubmitClick={handleSubmitClick} handleCancelClick={handleCancelClick}
          data={{name: props?.data?.deliveryAddress?.name,
          address: props?.data?.deliveryAddress}}
        />}
      </Row>
            {/* alert message */}
            {showAlertMsg && 
      <ModalMessage
          message="Are you sure you want to cancel this order? This cannot be undone." 
          // setErrorMsg={setShowLogoutMsg}
          confirmButton={true}
          handleConfirm={handleConfirmUpdateCancellationStatus}
          setShowAlertMsg={setShowAlertMsg}
        />
      }
      </>
  );
}
